import { render, staticRenderFns } from "./InfopointEditor.vue?vue&type=template&id=20b6b2ce"
import script from "./InfopointEditor.vue?vue&type=script&lang=js"
export * from "./InfopointEditor.vue?vue&type=script&lang=js"
import style0 from "./InfopointEditor.vue?vue&type=style&index=0&id=20b6b2ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports